module.exports = __webpack_public_path__ + "img/qr-code_white.0baaf3e1.png";